import { TwoColumnLayout } from 'layouts';
import type { EntityOptions, GroupDetail as GroupDetailType } from 'models';
import { canCreateAnnouncements } from 'permissions';
import { Card, Col, Icon, Row } from 'ui';
import { useUser } from 'features/auth';
import { ContentObjectFeed, CreateContentObjectTrigger } from 'features/feed';
import { GroupAdminsCard } from '../group-admins-card';
import { GroupHierarchyCard } from '../group-hierarchy-card';

type P = {
  getPathToEntityDetail: (id: string, options: EntityOptions) => string;
  group: GroupDetailType;
};

const GroupDetailAnnouncements = ({ getPathToEntityDetail, group }: P) => {
  const { railsUserData: viewer } = useUser();

  return (
    <TwoColumnLayout
      left={
        <Row gutter={[0, 'ms']}>
          {canCreateAnnouncements({ groupId: group.id, viewer }) ? (
            <Col span={24}>
              <Card marginBottom={false}>
                <CreateContentObjectTrigger groupId={group.id} />
              </Card>
            </Col>
          ) : null}
          <Col span={24}>
            <ContentObjectFeed
              emptyState={{
                description: {
                  subtitle: 'Any announcements will show up here once they’re created',
                  title: 'No announcements yet',
                },
                image: <Icon icon="horn-line" />,
              }}
              groupId={group.id}
            />
          </Col>
        </Row>
      }
      right={
        <>
          <GroupAdminsCard group={group} />
          <GroupHierarchyCard
            getPathToGroupDetail={(id) => getPathToEntityDetail(id, { entityType: 'group' })}
            group={group}
          />
        </>
      }
    />
  );
};

export default GroupDetailAnnouncements;
